module.exports = __webpack_public_path__ + "img/logo-cielo--gray.svg";